import React from 'react';
import { Box } from '@mui/material';
import { CameraMeasurementPanel } from '../../components/cameraMeasurement/CameraMeasurementPanel';
import { CAMERA_MEASUREMENT_GOLDENS } from '../../domain/cameraMeasurement/cameraMeasurementGoldens';

const colors = {
  ink: '#0f172a',
  ink2: '#4a5768',
  line: '#e3e8ef',
  bg: '#f4f6f9',
};

const GOLDENS: Array<{
  id: string;
  title: string;
  zoneId?: string;
  zoneName?: string;
  defaultScope?: 'CAMERA' | 'ZONE';
  override: typeof CAMERA_MEASUREMENT_GOLDENS.measured;
}> = [
  { id: 'measured', title: 'A. MEASURED', override: CAMERA_MEASUREMENT_GOLDENS.measured },
  { id: 'measured-zero', title: 'B. MEASURED ZERO', override: CAMERA_MEASUREMENT_GOLDENS.measuredZero },
  { id: 'limited', title: 'C. LIMITED / PRODUCER GAP', override: CAMERA_MEASUREMENT_GOLDENS.limitedProducerGap },
  { id: 'limited-observed', title: 'C2. LIMITED OBSERVED WALKWAY', override: CAMERA_MEASUREMENT_GOLDENS.limitedObservedWalkway },
  { id: 'not-measured', title: 'D. NOT_MEASURED / TELEMETRY_MISSING', override: CAMERA_MEASUREMENT_GOLDENS.notMeasuredTelemetry },
  { id: 'unsupported', title: 'E. MIXED METRIC / UNSUPPORTED FORKLIFT', override: CAMERA_MEASUREMENT_GOLDENS.unsupportedForklift },
  {
    id: 'zone',
    title: 'H. ZONE',
    zoneId: 'worksafety',
    zoneName: 'Walkway zone',
    defaultScope: 'ZONE',
    override: CAMERA_MEASUREMENT_GOLDENS.zone,
  },
];

const CameraMeasurementFixturePage: React.FC = () => {
  return (
    <Box data-testid="camera-measurement-fixture" sx={{ bgcolor: colors.bg, minHeight: '100vh', p: '16px', color: colors.ink }}>
      <Box component="h1" sx={{ m: 0, fontSize: 18, fontWeight: 700 }}>Safety overview</Box>
      <Box sx={{ fontSize: 11, color: colors.ink2, mb: '12px' }}>
        NOW → RECURRING → CONTROL → ACTION. Camera Measurement is compact instrumentation, not a parallel analytics product.
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1.45fr 1fr 1fr 1fr 128px' },
          bgcolor: '#f8fafc',
          border: `1px solid ${colors.line}`,
          borderBottom: 0,
          fontSize: 8.5,
          fontWeight: 750,
          letterSpacing: '.65px',
          textTransform: 'uppercase',
          color: '#7d8798',
          '& > div': { p: '7px 10px', borderRight: `1px solid ${colors.line}` },
        }}
      >
        <div>Zone / Policy</div>
        <div>Now</div>
        <div>Recurring</div>
        <div>Control</div>
        <div>Action</div>
      </Box>
      {GOLDENS.map((golden) => (
        <Box
          key={golden.id}
          data-testid={`camera-measurement-golden-${golden.id}`}
          sx={{ bgcolor: '#fff', border: `1px solid ${colors.line}`, mb: '10px', overflow: 'hidden' }}
        >
          <Box sx={{ fontSize: 10, fontWeight: 700, p: '6px 12px', borderBottom: `1px solid ${colors.line}` }}>
            {golden.title}
          </Box>
          <CameraMeasurementPanel
            siteId="yyz"
            deviceId="demo5"
            cameraId="cam_walkway_zone_demo"
            zoneId={golden.zoneId}
            zoneName={golden.zoneName}
            defaultScope={golden.defaultScope}
            presentation="compact"
            override={golden.override}
          />
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.45fr 1fr 1fr 1fr 128px' }, fontSize: 11 }}>
            <Box sx={{ p: '8px 12px', borderRight: `1px solid ${colors.line}` }}>Walkway · Near miss policy</Box>
            <Box sx={{ p: '8px 12px', borderRight: `1px solid ${colors.line}` }}>11 measured occurrences</Box>
            <Box sx={{ p: '8px 12px', borderRight: `1px solid ${colors.line}` }}>History building</Box>
            <Box sx={{ p: '8px 12px', borderRight: `1px solid ${colors.line}` }}>Walkway barrier</Box>
            <Box sx={{ p: '8px 12px' }}>Investigate</Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CameraMeasurementFixturePage;
